import React, { useState } from 'react'
import { Query } from 'react-apollo'
import { Div, P, LoadingIcon } from 'konsys-ui'
import PATH from '../../constants/path'
import { ACTIVATE_USER } from '../../constants/graph/query'
import { WidthContainer } from '../register/styled'
import Container from '../../components/container'
import ReturnPage from '../../components/common/return-page'
import { theme } from '../../styles/_variables'
import Banner from '../../images/member/banner.jpg'

const ActivePage = (props) => {
  const [isShowModal, setIsShowModal] = useState(false)
  return (
    <Query
      query={ACTIVATE_USER}
      variables={{
        token: props.match.params.token,
      }}
    >
    {
      ({ loading, data }) => {
        if (loading || !data) {
          return (
            <Div width='100vw' height='100vh' display='flex' alignItems='center' justifyContent='center'>
              <LoadingIcon large />
            </Div>
          )
        }
        return (
          <Container header={{
            type: 'title',
            img: Banner,
            title: 'บัญชีผู้ใช้',
            color: theme.color.tertiaryColor,
          }}
            blur={isShowModal}
          >
            <WidthContainer>
              <ReturnPage
                title={data.activateUser.success ? 'ยืนยันการลงทะเบียนผู้ใช้' : 'ลงทะเบียนผู้ใช้มีปัญหา'}
                buttonData={[
                  { title: 'กลับสู่หน้าแรก', style: 'inverse', link: PATH.home },
                  {
                    title: 'ไปยังบัญชีผู้ใช้',
                    style: 'inverse',
                    link: PATH.login,
                    type: 'login',
                  },
                ]}
                isShowModal={value => setIsShowModal(value)}
              >
              {
                data.activateUser.success
                  ? [
                    <P
                      key='text1'
                      display='block'
                      textAlign='center'
                      style={{ fontWeight: 'bold' }}
                      color={theme.color.lightGrey}>ยืนยันการลงทะเบียนเสร็จสมบูรณ์ คุณสามารถใช้บัญชีผู้ใช้นี้ในการติดตามสถานะ</P>,
                    <P
                      key='text2'
                      display='block'
                      textAlign='center'
                      style={{ fontWeight: 'bold' }}
                      color={theme.color.lightGrey}>หรือตรวจสอบประวัติคำร้องของใบเสนอราคา และคำสั่งพิมพ์ของคุณได้</P>,
                  ]
                  : [
                    <P key='text1' display='block' textAlign='center' style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>การลงทะเบียนมีปัญหา กรุณาลองใหม่ภายหลัง</P>,
                  ]
              }
              </ReturnPage>
            </WidthContainer>
          </Container>
        )
      }
    }
    </Query>
  )
}

export default ActivePage



// WEBPACK FOOTER //
// ./src/pages/activate/index.jsx